import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface AuditLogRow {
  id: number;
  tenant_id: number | null;
  actor_id: number | null;
  actor_type: string;
  actor_email: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  source: string;
  source_ip: string | null;
  user_agent: string | null;
  request_id: string | null;
  http_method: string | null;
  http_path: string | null;
  outcome: string;
  metadata: Record<string, unknown> | null;
  prev_hash: string | null;
  hash: string;
  created_at: string;
}

export interface AuditLogQuery {
  search?: string;
  tenant_id?: number;
  action?: string;
  resource_type?: string;
  actor_id?: number;
  outcome?: string;
  source?: string;
  from?: string;
  to?: string;
  actor_email?: string;
  source_ip?: string;
  resource_id?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  page_size?: number;
}

export interface AuditVerifyResult {
  valid: boolean;
  count: number;
  broken_at_id?: number;
  reason?: string;
}

function toParams(query: AuditLogQuery): URLSearchParams {
  const q = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.set(k, String(v));
  });
  return q;
}

@Injectable({ providedIn: 'root' })
export class AuditLogApiService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl.replace(/\/$/, '');

  list(query: AuditLogQuery = {}) {
    return this.http.get<{
      data: {
        result: AuditLogRow[];
        total: number;
        page: number;
        page_size: number;
      };
    }>(`${this.base}/audit?${toParams(query)}`);
  }

  /** Same filters as list(); the server streams a CSV attachment. */
  exportCsv(query: AuditLogQuery = {}) {
    return this.http.get(`${this.base}/audit/export?${toParams(query)}`, {
      responseType: 'blob',
    });
  }

  verify() {
    return this.http.get<{ data: AuditVerifyResult }>(`${this.base}/audit/verify`);
  }
}
